export default __webpack_public_path__ + "static/media/expl_gradcam_15_DE.9353b72d.png";